module.exports = __webpack_public_path__ + "img/7_151.3d338e53.png";